/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	// $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
	// 	if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
	// 		$(this).wrap("<div class='widescreen responsive-embed'/>");
	// 	} else {
	// 		$(this).wrap("<div class='responsive-embed'/>");
	// 	}
	// });

// Ensure forms are shown when window.dialog.showModal() is called
window.dialog.addEventListener('show', function() {
	showForms();
});


	if ($('.page-template-template-sitemap .site-content').length) {
		$('.page-template-template-sitemap .site-content').prepend('<h2>Sitemap</h2>');
	}


// Prevent body scroll when form is submitting via AJAX
// $(document).on('gform_post_render', function() {
// 	$('body').addClass('no-scroll');  // Add class to disable scroll during the form action
//   });
  
//   // Enable scroll when done
//   $(document).on('gform_ajax_success', function() {
// 	$('body').removeClass('no-scroll');  // Re-enable scroll
//   });

    $(document).on('gform_post_render', function() {
        $('body').addClass('no-scroll');  // Add class to disable scroll during the form action
    });
    
    // Enable scroll when done
    $(document).on('gform_ajax_success', function() {
        $('body').removeClass('no-scroll');  // Re-enable scroll
    });


// Smooth fade-to-top effect
$('html, body').animate({ scrollTop: 0 }, 'slow');
  
// removing tabindex from hidden inputs on franchisor form

	setTimeout(() => {
		const rangeinputs = document.querySelectorAll('.franchisor-form .ginput_container_slider input[type=number]');
		rangeinputs.forEach(rangeinput => {
			rangeinput.tabIndex=-1;
		});
		console.log('tabindex removal squad');
	}, "10000");
});